import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

const RedirectLoader = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;

  span {
    color: red;
    font-weight: 700;
  }

  h3 {
    color: var(--white);
  }

  a {
    display: block;
    margin: 20px auto;
    border: 1px solid var(--white);
    width: fit-content;
    color: var(--white);
    padding: 10px 20px;
    border-radius: 100px;
    transition: 0.4s;
    background: var(--txt);

    &:hover {
      background: var(--white);
      color: var(--txt);
    }
  }
`;

const RedirectSpinner = ({ path = "/login" }) => {
  const [count, setCount] = useState(5);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fullPath = location.pathname + location.search;
    const interval = setInterval(() => {
      setCount((prevCount) => --prevCount);
    }, 1000);
    count === 0 &&
      navigate(`${path}`, {
        state: fullPath,
      });
    return () => clearInterval(interval);
  }, [count, navigate, location, path]);

  return (
    <RedirectLoader className="txt_color">
      <div className="container">
        <h3 className="monserrat_font">
          you do not have sufficient privileges to access the resource. <br />{" "}
          Redirecting to you in <span>{count}</span> second.
        </h3>
        <Link to="/">Login</Link>
      </div>
    </RedirectLoader>
  );
};

export default RedirectSpinner;
